import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
import { ratedTestimonials } from '../data/megaPack';
export function RatedTestimonials() {
  return <section className="bg-cream-100 py-10 sm:py-16" aria-label="Testimonios de familias que ya usan el Mega Pack" data-id="element-225" data-mp="17l8fxtg4ydwb">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-226" data-mp="1hkz6jk1ks8r4">
        <p className="text-center font-display text-[0.7rem] font-700 uppercase tracking-[0.2em] text-teal-600 sm:text-xs" data-id="element-227" data-mp="1hjedjyuwsxvd">
          Compras verificadas · 5 estrellas
        </p>
        <h2 className="mt-2 text-center font-display text-2xl font-800 leading-tight text-teal-900 sm:text-3xl" data-id="element-228" data-mp="1rar4mo8vvk0c">
          Actividades reales, en casas reales
        </h2>

        <div className="mt-6 grid gap-4 sm:mt-10 sm:grid-cols-3 sm:gap-5" data-id="element-229" data-mp="20bpcjhmg0bo7">
          {ratedTestimonials.map(item => <figure key={item.name} className="flex h-full flex-col overflow-hidden rounded-2xl bg-cream-50 shadow-card ring-1 ring-teal-900/5 transition-transform duration-150 ease-out active:scale-[0.99] sm:hover:-translate-y-0.5" data-id="element-230" data-mp="axkiuzbbtm59">
              <div className="relative" data-id="element-231" data-mp="6xvkufqa2lt9">
                <img src={item.photo} alt={item.photoAlt} className="aspect-[4/3] w-full object-cover object-center sm:aspect-[4/5]" loading="lazy" data-id="element-232" data-mp="6wkeq99d11yz" />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full bg-teal-900/85 px-2.5 py-1 font-display text-[0.6rem] font-800 uppercase tracking-[0.12em] text-cream-50 backdrop-blur" data-id="element-233" data-mp="kqbmbc3j6bs2">
                  <BadgeCheckIcon className="h-3.5 w-3.5 text-gold-400" aria-hidden="true" data-id="element-234" data-mp="upaocbtsj963" />
                  Compra verificada
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 sm:p-5" data-id="element-235" data-mp="2wfvwhmqfddaa">
                <div className="flex items-center gap-0.5" aria-label="5 de 5 estrellas" data-id="element-236" data-mp="2whp4b5cry3jv">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-237" data-mp="7nsbp5x12s9b" data-mpi={index} />)}
                </div>

                <blockquote className="mt-2.5 text-[0.85rem] leading-relaxed text-ink/85 sm:text-[0.9rem]" data-id="element-238" data-mp="glb0mldslqqh">
                  “{item.quote}”
                </blockquote>

                <figcaption className="mt-auto flex items-center gap-2.5 pt-4" data-id="element-239" data-mp="qkab89i4bwg4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-teal-700 font-display text-[0.65rem] font-800 text-cream-50" aria-hidden="true" data-id="element-240" data-mp="lna3zv9j8nnf">
                    {item.initials}
                  </span>
                  <div className="min-w-0" data-id="element-241" data-mp="19bbbd0uz5y19">
                    <p className="truncate font-display text-[0.8rem] font-700 text-teal-800" data-id="element-242" data-mp="19a05mvhyyg7i">
                      {item.name}
                    </p>
                    <p className="truncate text-[0.7rem] text-clay" data-id="element-243" data-mp="1nyibscmu3dlw">
                      {item.location} — {item.role}
                    </p>
                  </div>
                </figcaption>
              </div>
            </figure>)}
        </div>
      </div>
    </section>;
}